module.exports = __webpack_public_path__ + "static/sponsorship_img-07-e@2x-af7c8a420f0cd5649292ef9bdc202da2.jpg";